import { Icon, IconButton, Theme } from '@mui/material';
import { SxProps } from '@mui/system';
import { ActionCreatorWithPayload } from '@reduxjs/toolkit';
import { useAppDispatch } from 'common';
import { FC } from 'react';
import { DeviceType, useBreakpoint } from '../../../../hooks/useBreakpoint';

export type RecipeCategoryGridRowCollapseButtonProps = {
  categoryId: string;
  isCollapsed: boolean;
  collapseAction: ActionCreatorWithPayload<
    {
      categoryId: string;
      isCollapsed: boolean;
    },
    string
  >;
  setRecomputeRowHeights?: () => void;
  sx?: SxProps<Theme>;
};

export const RecipeCategoryGridRowCollapseButton: FC<RecipeCategoryGridRowCollapseButtonProps> = (
  props: RecipeCategoryGridRowCollapseButtonProps
) => {
  const dispatch = useAppDispatch();
  const { deviceType } = useBreakpoint();

  const isCollapsed = props.isCollapsed;
  const handleOnClick = () =>
    dispatch(props.collapseAction({ categoryId: props.categoryId, isCollapsed: !isCollapsed }));

  return (
    <IconButton onClick={handleOnClick} tabIndex={0} sx={{ color: (theme) => theme.palette.grey[600], ...props.sx }}>
      {!isCollapsed ? (
        <Icon className='fa-angle-up' fontSize={deviceType === DeviceType.Desktop ? 'small' : 'medium'} />
      ) : (
        <Icon className='fa-angle-down' fontSize={deviceType === DeviceType.Desktop ? 'small' : 'medium'} />
      )}
    </IconButton>
  );
};
